import { IClassname } from '@/lib/shared/model/classname';

export const Garage = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14438_326)">
        <path
          d="M1.30396 15.9998C1.30396 19.8974 2.85228 23.6354 5.60833 26.3914C8.36437 29.1475 12.1024 30.6958 16 30.6958C19.8976 30.6958 23.6356 29.1475 26.3917 26.3914C29.1477 23.6354 30.696 19.8974 30.696 15.9998C30.696 12.1021 29.1477 8.36412 26.3917 5.60808C23.6356 2.85204 19.8976 1.30371 16 1.30371C12.1024 1.30371 8.36437 2.85204 5.60833 5.60808C2.85228 8.36412 1.30396 12.1021 1.30396 15.9998Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.1377 16C5.1377 18.8808 6.28211 21.6437 8.31919 23.6808C10.3563 25.7179 13.1191 26.8623 16 26.8623C18.8808 26.8623 21.6437 25.7179 23.6808 23.6808C25.7179 21.6437 26.8623 18.8808 26.8623 16C26.8623 13.1191 25.7179 10.3563 23.6808 8.31919C21.6437 6.28211 18.8808 5.1377 16 5.1377C13.1191 5.1377 10.3563 6.28211 8.31919 8.31919C6.28211 10.3563 5.1377 13.1191 5.1377 16Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1947 14.0832C19.1947 14.761 18.9254 15.4111 18.4461 15.8904C17.9668 16.3697 17.3167 16.639 16.6388 16.639H14.083V11.5273H16.6388C17.3167 11.5273 17.9668 11.7966 18.4461 12.2759C18.9254 12.7552 19.1947 13.4053 19.1947 14.0832Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.083 21.7503V16.6387"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14438_326">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
